import { render, staticRenderFns } from "./counterWidget.vue?vue&type=template&id=5073a424&scoped=true&"
import script from "./counterWidget.vue?vue&type=script&lang=js&"
export * from "./counterWidget.vue?vue&type=script&lang=js&"
import style0 from "./counterWidget.vue?vue&type=style&index=0&id=5073a424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5073a424",
  null
  
)

export default component.exports